import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const TicTacToe = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Tic Tac Toe</h1>
        <p>Play the classic Tic Tac Toe game coded in Python.</p>
        <ImageWithFallback src="/Tic_tac_toe.png" alt="Tic Tac Toe" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project is a simple Tic Tac Toe game built using Python.</p>
        <h2>Download</h2>
        <a href="/tic_tac_toe.py" download>Download tic_tac_toe.py</a>
        <h2>How to Play</h2>
        <p>Run the Python file and play against another player or the computer.</p>
      </div>
    </div>
  );
};

export default TicTacToe;
